import { LOCATION_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const LocationService = {
  getAll: (params: any) => requests.get(`${LOCATION_URL}`, params),
  getList: (params?: any) => requests.get(`${LOCATION_URL}/list`, params),
  getTree: (params: any) => requests.get(`${LOCATION_URL}/tree`, params),
  create: (params: any) => requests.post(`${LOCATION_URL}`, params),
  getSingle: (id: number) => requests.get(`${LOCATION_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${LOCATION_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${LOCATION_URL}/${id}`),
};